import Vue from 'vue'
import Router from 'vue-router'

// 首页相关
import index from '@/views/index'
import suggest from '@/views/index/suggest'
import download from '@/views/index/download'
import downloadDetail from '@/views/index/downloadDetail'
import search from '@/views/search'
import news from '@/views/index/news'
// 中心概况
import introduce from '@/views/introduce'
import itroIndex from '@/views/introduce/itroIndex'
import orgStrut from '@/views/introduce/orgStrut'
import team from '@/views/introduce/team'
import direction from '@/views/introduce/direction'
import item from '@/views/introduce/item'
import teamDetail from '@/views/introduce/detail'
// 研究成果
import studyResult from '@/views/studyResult'
import academicPaper from '@/views/studyResult/academicPaper'
import publications from '@/views/studyResult/publications'
import researchReport from '@/views/studyResult/researchReport'
import achievementApply from '@/views/studyResult/achievementApply'
import studyResultDetail from '@/views/studyResult/detail'
// 学术交流
import academic from '@/views/academic'
import acaIndex from '@/views/academic/acaIndex'
import opinion from '@/views/academic/opinion'
import opnDetail from '@/views/academic/opnDetail'
import trendDetail from '@/views/academic/trendDetail'
// 应急课堂
import emrClass from '@/views/emrClass'
import onlineClass from '@/views/emrClass/onlineClass'
import lectures from '@/views/emrClass/lectures'
import eclass from '@/views/emrClass/eclass'
import knowledge from '@/views/emrClass/knowledge'
import emrClassDetail from '@/views/emrClass/detail'
import knowledgeDetail from '@/views/emrClass/knowledgeDetail'
// 专家库
import experts from '@/views/experts'
import expertsDetail from '@/views/experts/detail'
// 案例库
import dataAndCases from '@/views/dataAndCases'
import casesDetail from '@/views/dataAndCases/detail'
// 测试
import test from '@/views/test'
Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/test',
      name: 'test',
      component: test,
    },
    {
      path: '/index/suggest',
      name: 'suggest',
      component: suggest
    },
    {
      path: '/index/download',
      name:'download',
      redirect: '/index/download/academic',
    },
    {
      path: '/index/download/:type',
      //name: 'download',
      component: download,
    },
    {
      path: '/index/download/:type/detail', // academic. knowledge, video
      name: 'downloadDetail',
      component: downloadDetail,
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce,
      redirect: '/introduce/itroIndex',
      children: [{
          path: 'itroIndex',
          name: 'itroIndex',
          component: itroIndex
        },
        {
          path: 'orgStrut',
          name: 'orgStrut',
          component: orgStrut
        },
        {
          path: 'team',
          name: 'team',
          component: team,
        },
        {
          path: 'detail',
          name: 'teamDetail',
          component: teamDetail
        },
        {
          path: 'direction',
          name: 'direction',
          component: direction
        },
        {
          path: 'item',
          name: 'item',
          component: item
        },
      ]
    },
    {
      path: '/studyResult',
      name: 'studyResult',
      component: studyResult,
      redirect: '/studyResult/publications',
      children: [{
          path: 'academicPaper',
          name: 'academicPaper',
          component: academicPaper
        },
        {
          path: 'publications',
          name: 'publications',
          component: publications
        },
        {
          path: 'researchReport',
          name: 'researchReport',
          component: researchReport
        },
        {
          path: 'achievementApply',
          name: 'achievementApply',
          component: achievementApply
        },
        {
          path: 'detail',
          name: 'studyResultDetail',
          component: studyResultDetail
        }
      ]
    },
    {
      path: '/academic',
      name: 'academic',
      component: academic,
      redirect: '/academic/trends',
      children: [{
          path: 'trends',
          name: 'trends',
          component: acaIndex
        },
        {
          path: 'opinion',
          name: 'opinion',
          component: opinion
        },
        {
          path: 'opinion/opnDetail',
          name: 'opnDetail',
          component: opnDetail
        },
        {
          path: 'trends/detail',
          name: 'trendDetail',
          component: trendDetail
        }
      ]
    },
    {
      path: '/emrClass',
      name: 'emrClass',
      component: emrClass,
      redirect: '/emrClass/knowledge',
      children: [{
          path: 'knowledge',
          name: 'knowledge',
          component: knowledge
        },
        {
          path:'knowledgeDetail',
          name:'knowledgeDetail',
          component:knowledgeDetail
        },
        {
          path: 'onlineClass',
          name: 'onlineClass',
          component: onlineClass
        },
        {
          path: 'lectures',
          name: 'lectures',
          component: lectures
        },
        {
          path: 'eclass',
          name: 'eclass',
          component: eclass
        }
      ]
    },
    {
      path: '/experts',
      name: 'experts',
      component: experts,
    },
    {
      path: '/experts/detail',
      name: 'expertsDetail',
      component: expertsDetail
    },
    {
      path:'/emrClass/detail',
      name:'emrClassDetail',
      component:emrClassDetail
    },
    {
      path:'/index/news',
      name:'news',
      component:news,
    },
    {
      path: '/dataAndCases',
      redirect: '/dataAndCases/laws',
    },
    {
      path: '/dataAndCases/:type',
      name: 'dataAndCases',
      component: dataAndCases,
    },
    {
      path: '/dataAndCases/:type/detail',
      name: 'casesDetail',
      component: casesDetail
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },

  ]
})